<template>
  <v-row align="center" justify="center" v-if="service">
    <v-col v-if="service" cols="12" sm="8" md="6">
      <h1>{{formatedDate(service.date)}}</h1>
      <v-card class="mb-2" v-for="comment in service.comments">
        <v-list-item dense color="purple" class="weekday">
          <v-list-item-content></v-list-item-content>
          <div class="data-frame">
            <div class="rating-frame">
              <v-rating
                class="stars"
                right
                half-increments
                readonly
                small
                dense
                color="green"
                background-color="green"
                :value="comment.rating"
              ></v-rating>
              <span class="rating">({{comment.rating.toFixed(2)}})</span>
            </div>
          </div>
        </v-list-item>
        <v-card-text>
          <v-card flat class="mb-2" outlined v-for="plate in comment.content">
            <div class="type">{{ plate.label }}</div>
            <v-card-title class="title">
              {{ plate.name }}
              <v-spacer></v-spacer>
              <v-rating readonly small dense :value="plate.rating"></v-rating>
            </v-card-title>
            <v-card-text>
              <v-icon>mdi-format-quote-open</v-icon>
              <span class="comment">{{ plate.comment }}</span>
              <v-icon>mdi-format-quote-close</v-icon>
            </v-card-text>
          </v-card>
          <span class="sign">{{comment.sign}}</span>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import firebase from "firebase";
import moment from "moment";

export default {
  props: { id: String },
  name: "recipe",
  data() {
    return {
      service: null
    };
  },
  created: function() {
    moment.locale("ES");
    firebase
      .firestore()
      .collection("services")
      .doc(this.id)
      .get()
      .then(ref => {
        this.service = ref.data();
        console.log(this.service);
      });
  },
  methods: {
    formatedDate: function(date) {
      return (
        moment(new Date(date.seconds * 1000)).format("LL") +
        " (" +
        moment(new Date(date.seconds * 1000)).format("dddd") +
        ")"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.data-frame {
  text-align: right;
  .rating-frame {
    display: inline-block;
    .stars {
      display: inline-block;
    }
    .rating {
      font-size: 0.8em;
      width: 50px;
      text-align: center;
      font-weight: bold;
      display: inline-block;
      color: grey;
    }
  }
}

.comment {
  font-size: 1.2em;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif !important;
  color: darkgrey;
}
.sign {
  font-size: 1.1em;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif !important;
  display: block;
  text-align: right;
  padding-right: 20px;
  font-style: italic;
  color: grey;
}
.type {
  border-radius: 5px 0px 5px 0px !important;
  display: inline-block;
  margin: 0px;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: bold;
  margin-bottom: 0px;
}
.title {
  margin-top: 0px !important;
  padding-top: 0px;
}
</style>